import { SORT_LABELS, type SortMode } from '../utils/sort';
import { ViewerToggle } from './ViewerToggle';

interface Props {
  showCompleted: boolean;
  onToggleCompleted: () => void;
  completedCount: number;
  activeCount: number;
  sortMode: SortMode;
  onSortChange: (mode: SortMode) => void;
  viewer?: string;
  onViewerChange?: (v: string) => void;
}

const MODES: SortMode[] = ['smart', 'due', 'priority', 'age'];

export function ListFilters({
  showCompleted,
  onToggleCompleted,
  completedCount,
  activeCount,
  sortMode,
  onSortChange,
  viewer,
  onViewerChange,
}: Props) {
  return (
    <div className="list-filters">
      <span className="list-filters-count">
        <span className="list-filters-count-num">{activeCount}</span>
        <span className="list-filters-count-suffix">
          {' '}active{completedCount > 0 && ` · ${completedCount} completed`}
        </span>
      </span>
      <div className="list-filters-right">
        {viewer !== undefined && onViewerChange && (
          <span className="list-filters-viewer">
            <ViewerToggle value={viewer} onChange={onViewerChange} />
          </span>
        )}
        <label className="sort-control">
          <span className="muted">Sort:</span>
          <select
            value={sortMode}
            onChange={(e) => onSortChange(e.target.value as SortMode)}
            aria-label="Sort tasks"
          >
            {MODES.map((m) => (
              <option key={m} value={m}>
                {SORT_LABELS[m]}
              </option>
            ))}
          </select>
        </label>
        {completedCount > 0 && (
          <button
            className={`filter-chip ${showCompleted ? 'is-on' : ''}`}
            onClick={onToggleCompleted}
            aria-pressed={showCompleted}
          >
            {showCompleted ? '✓ Completed' : 'Show completed'}
          </button>
        )}
      </div>
    </div>
  );
}
